import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=488a3f2c&scoped=true&"
import script from "./PromotionDetail.vue?vue&type=script&lang=js&"
export * from "./PromotionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&id=488a3f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a3f2c",
  null
  
)

export default component.exports